import { render } from "./FollowUpEmail.vue?vue&type=template&id=049eddb0&scoped=true"
import script from "./FollowUpEmail.vue?vue&type=script&lang=js"
export * from "./FollowUpEmail.vue?vue&type=script&lang=js"

import "./FollowUpEmail.vue?vue&type=style&index=0&id=049eddb0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049eddb0"]])

export default __exports__